import { atomWithReset } from "jotai/utils";

export const locationAllDTOAtom = atomWithReset({
  locationINData: {
    zipCode: "",
    address: "",
    country: "",
    city: "",
    state: "",
    latitude: "",
    longitude: "",
  },
  projectData: {
    projectName: "",
    projectDescription: "",
    customerName: "",
    currency: "",
    dateFormat: "YYYY/MM/DD",
    numberFormat: "1,234,567.89",
    projectType: "ANSI",
  },
});
